import createAxiosInstance from '../createAxiosInstance/createAxiosInstance.js';
import interstitial from '../interstitial/interstitial.js';
import config from '../config/config.js';
import termsOfService from '../termsOfService/termsOfService.js';
import 'axios';
import '@babel/runtime/helpers/esm/regeneratorRuntime';
import '@babel/runtime/helpers/esm/asyncToGenerator';

/**
 * @typedef AemServiceCreatorParams
 * @type {import('./createAxiosInstance').AemAxiosInstanceCreatorParams}
 */

/**
 * @param {AemServiceCreatorParams} axiosInstanceParams
 */
function createService(axiosInstanceParams) {
  var aemAxiosInstance = createAxiosInstance(axiosInstanceParams);
  return {
    interstitial: interstitial(aemAxiosInstance),
    config: config(aemAxiosInstance),
    termsOfService: termsOfService(aemAxiosInstance)
  };
}

export { createService as default };
//# sourceMappingURL=createService.js.map
